import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1eae2ec2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mxa-nologin-main" }
const _hoisted_2 = {
  class: "mxa-nologin-main-explanation",
  "data-test": "desc"
}
const _hoisted_3 = {
  class: "mxa-nologin-main-explanation-caution",
  "data-test": "caution"
}
const _hoisted_4 = { class: "mxa-nologin-main-inputgroup" }
const _hoisted_5 = { class: "mxa-nologin-main-input" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "mxa-nologin-input-margin" }
const _hoisted_8 = { class: "mxa-nologin-main-checkbox" }
const _hoisted_9 = { class: "d-flex justify-content-end" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right" }, null, -1))
const _hoisted_12 = { class: "container-fluid mb-2 p-0" }
const _hoisted_13 = { class: "row justify-content-center p-0" }
const _hoisted_14 = { class: "mxa-nologin-main-button-double" }
const _hoisted_15 = { class: "mxa-nologin-main-button-double" }

import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import BasePassword from '@/components/common/input/BasePassword.vue'
import BaseButton from '@/components/common/button/BaseButton.vue'
import BaseCheckbox from '@/components/common/input/BaseCheckbox.vue'
import ErrorMessage from '@/components/common/screen/ErrorMessage.vue'
import * as log from '@/model/util/log/Logger'
import {
  initDom,
  useLoginAuth,
  auth,
  topRedirect,
  resetpassword,
  useErrorMsg,
} from '@/model/components/users/userLoginAuth'
import NologinTitle from '@/components/main/nologin/NologinTitle.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginAuth',
  props: {
  // ユーザー名
  username: {
    type: String,
    default: undefined,
  },
  // リダイレクト
  redirect: {
    type: String,
    default: undefined,
  },
  // ダウンロードキー
  downloadKey: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props

log.trace(`LoginAuth setup start.`)

// プロパティ定義


// 状態
const store = useStore()
const router = useRouter()
const errorState = useErrorMsg()
const state = useLoginAuth(props)

log.debug(`LoginAuth props: ${JSON.stringify(props)}, state: ${JSON.stringify(state)}`)

// onMountedの登録
onMounted(async () => {
  log.trace('LoginAuth onMounted start.')
  // 初期処理
  // F5等でusernameが設定されていない場合はTOP画面に遷移
  await initDom(state, store, router)
  log.trace('LoginAuth onMounted end.')
})

log.trace(`LoginAuth setup end.`)

// ログインボタンクリック処理
const onclick = () => {
  log.trace(`LoginAuth onClick start.`)
  // API実施して成功の場合はダウンロード画面に遷移、エラーの場合はエラーメッセージを設定
  auth(state, store, router, errorState)
  log.trace(`LoginAuth onClick end.`)
}

// 戻るボタン処理
const onback = () => {
  log.trace(`LoginAuth onback start.`)
  // TOP画面に戻る
  // リダイレクト情報は保持するがエラー情報は削除
  topRedirect(state, store, router)
  log.trace(`LoginAuth onback end.`)
}

// パスワードリセットリンク処理
const resetClick = () => {
  log.trace(`LoginAuth resetpassword start.`)
  // ワンタイムパスワード送信画面に遷移
  resetpassword(state, router)
  log.trace(`LoginAuth resetpassword end.`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NologinTitle, {
      title: _ctx.$t('body.login.title')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('body.login.message')), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('body.login.message2')), 1),
    _createElementVNode("form", {
      action: "",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
      novalidate: ""
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("input", {
            type: "text",
            name: "username",
            autocomplete: "username",
            value: _unref(state).username,
            hidden: ""
          }, null, 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(BasePassword, {
              placeholder: _ctx.$t('body.login.password.placeholder'),
              autocomplete: "current-password",
              "init-focus": true,
              modelValue: _unref(state).password,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).password) = $event)),
              "data-test": "password",
              passwordStatus: !_unref(state).dispPassword,
              onInputPasswordEnter: onclick,
              onInputTextEnter: onclick
            }, null, 8, ["placeholder", "modelValue", "passwordStatus"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(BaseCheckbox, {
              modelValue: _unref(state).dispPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).dispPassword) = $event)),
              label: _ctx.$t('body.common.passowrd.disp.passowrd'),
              domId: "loginAuthPassDisp"
            }, null, 8, ["modelValue", "label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("button", {
            type: "button",
            class: "btn mxa-nologin-main-reset",
            "data-test": "reset_link",
            onClick: resetClick
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('body.top.reset.message')) + " ", 1),
            _hoisted_11
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { error: _unref(errorState) }, null, 8, ["error"]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(BaseButton, {
              loading: _unref(state).loading,
              isDisabled: _unref(state).loading,
              label: _ctx.$t('body.login.button.login.title'),
              onButtonClick: onclick,
              "data-test": "login_button"
            }, null, 8, ["loading", "isDisabled", "label"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(BaseButton, {
              loading: false,
              isDisabled: _unref(state).loading,
              label: _ctx.$t('body.login.button.back.title'),
              onButtonClick: onback,
              "data-test": "back_button"
            }, null, 8, ["isDisabled", "label"])
          ])
        ])
      ])
    ], 32)
  ]))
}
}

})